// extracted by mini-css-extract-plugin
export default {"about_hero":"about_about_hero__a2Ugp","hero_desc":"about_hero_desc__RFwuk"};